// Sort keywords by highest ratio of keyword value to reviews count
// (this value will be INFINITY if the reviews count is 0; this is expected)

import { KeywordReviewCrossAnalysisLocationData } from "../../types/keywordReviewCrossAnalysisData";

// If the ratio is the same, sort by highest keyword value
export const sortKeywordsByNotMeetingExpectations = (
  locationData: KeywordReviewCrossAnalysisLocationData
) =>
  [...locationData.keywords]
    .sort((a, b) => {
      const aRatio = a.keyword_value / a.reviews_count;
      const bRatio = b.keyword_value / b.reviews_count;

      if (aRatio === bRatio) {
        return b.keyword_value - a.keyword_value;
      }

      return bRatio - aRatio;
    })
    .map((keyword) => ({
      ...keyword,
      ratio: keyword.keyword_value / keyword.reviews_count
    }));
// Sort keywords by highest ratio of reviews count to keyword value
// (this value will be 0 if the keyword value is 0; this is expected)
// If the ratio is the same, sort by highest reviews count
// Filter out keywords with 0 reviews count, because these words do not have room for growth if there are no reviews
export const sortKeywordsByRoomForGrowth = (
  locationData: KeywordReviewCrossAnalysisLocationData
) =>
  [...locationData.keywords]
    .filter((keyword) => keyword.reviews_count > 0)
    .sort((a, b) => {
      const aRatio = a.reviews_count / a.keyword_value;
      const bRatio = b.reviews_count / b.keyword_value;

      if (aRatio === bRatio) {
        return b.reviews_count - a.reviews_count;
      }

      return bRatio - aRatio;
    })
    .map((keyword) => ({
      ...keyword,
      ratio: keyword.reviews_count / keyword.keyword_value
    }));
